export class AddressQuoteWizardInputComponentStepTemplateProvider {
    constructor(
        public addressLineOneModelBinding: string,
        public addressLineTwoModelBinding: string,
        public cityModelBinding: string,
        public stateModelBinding: string,
        public zipModelBinding: string) {
    }

    public getTemplate(): string {
        return `<address-input
                address-line-one-model-binding="${this.addressLineOneModelBinding}"
                address-line-two-model-binding="${this.addressLineTwoModelBinding}"
                city-model-binding="${this.cityModelBinding}"
                state-model-binding="${this.stateModelBinding}"
                zip-model-binding="${this.zipModelBinding}"
                on-back-binding="vm.goBack()"
                on-next-binding="vm.goNext()"
                >`;
    }
}